// getFather.ts is a function that returns the father of the current page.

export const ROOM_FATHER_ROUTES = ["showall", "myrooms", "favorite", "organization", "activity"] as const;

/**
 * Resolves the route name to use when leaving a room.
 * Unknown origins fall back to Show All.
 */
export function resolveRoomFatherRoute(father: string): string {
    if ((ROOM_FATHER_ROUTES as readonly string[]).includes(father)) {
        return father;
    }
    return "showall";
}

/**
 * Gets the breadcrumb name based on the father parameter
 * @param context The Vue component context (usually `this`)
 * @param father The identifier for the current page's father
 * @returns The breadcrumb name as a string
 */
export function getBreadcrumbName(context, father) {
    switch (father) {
        case "showall":
            return context.$t("Show All");
        case "myrooms":
            return context.$t("My Rooms");
        case "favorite":
            return context.$t("Favorites");
        case "organization":
            return context.$t("Organizations");
        case "activity":
            return context.$t("Activity");
        default:
            return context.$t("Show All");
    }
}

/**
 * Icon class for the room breadcrumb origin
 */
export function getBreadcrumbIcon(father: string): string {
    switch (father) {
        case "myrooms":
            return "fa-solid fa-house";
        case "showall":
            return "fa-solid fa-list-ul";
        case "favorite":
            return "fa-solid fa-star";
        case "organization":
            return "fa-solid fa-building";
        case "activity":
            return "fa-solid fa-bell";
        default:
            return "fa-solid fa-house";
    }
}

export function isRoomFatherRoute(name: string): boolean {
    return (ROOM_FATHER_ROUTES as readonly string[]).includes(name);
}
